export const calculateSize = (
  width: number,
  aspectRatio: number,
): { width: number; height: number } => {
  return { width, height: Math.round(width * aspectRatio) };
};
